import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TOAST_KEY } from './core/models/app.constants';
import { UpdateService } from './core/services/update.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, ToastModule, DialogModule, ButtonModule, AsyncPipe],
    template: `
        <p-toast [key]="toastKey" position="top-right" />
        <router-outlet />

        @if (updateAvailable$ | async) {
            <p-dialog
                header="Nueva versión disponible"
                [modal]="true"
                [closable]="false"
                [dismissableMask]="false"
                [style]="{ width: '380px' }"
                [visible]="true">
                <p>Hay una nueva versión de la aplicación. ¿Desea actualizar?</p>
                <ng-template #footer>
                    <p-button
                        label="Actualizar"
                        icon="pi pi-refresh"
                        (click)="activateUpdate()"
                        severity="success"
                        autofocus />
                </ng-template>
            </p-dialog>
        }
    `
})
export class AppComponent {
    private updateService = inject(UpdateService);
    updateAvailable$ = this.updateService.updateAvailable$;
    readonly toastKey = TOAST_KEY;

    activateUpdate(): void {
        this.updateService.activateUpdate();
    }
}
